import { ref } from 'vue';

const show = ref<boolean>(false);

export function useSidebar() {
  return {
    show,
  };
}
